import { render, staticRenderFns } from "./AppLoadingScreen.vue?vue&type=template&id=8dd2515e&scoped=true&"
import script from "./AppLoadingScreen.vue?vue&type=script&lang=js&"
export * from "./AppLoadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./AppLoadingScreen.vue?vue&type=style&index=0&id=8dd2515e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd2515e",
  null
  
)

export default component.exports